var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#E06E3A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_72164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.54 15.9649C17.82 16.1349 18.18 16.1349 18.46 15.9649L26.86 10.6649C26.35 10.2549 25.71 10.0049 25 10.0049H11C10.27 10.0049 9.62 10.2749 9.1 10.7049L17.54 15.9749V15.9649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.77 11.8549L19.26 17.2349V17.2249C18.88 17.4649 18.44 17.5849 18 17.5849C17.56 17.5849 17.13 17.4649 16.75 17.2249L8.21 11.9049C8.08 12.2449 8 12.6049 8 12.9949V22.9949C8 24.6549 9.34 25.9949 11 25.9949H25C26.66 25.9949 28 24.6549 28 22.9949V12.9949C28 12.5949 27.92 12.2049 27.77 11.8549Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_72164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.3282e48911f1d1fd74d6fc1d265ae36f.svg";
export { ForwardRef as ReactComponent };